import { getCFDAppUrl } from 'pages/views/devices/utils';

interface StaticImagePathProps {
  image: string | undefined;
  srcSetScale?: '2x' | '3x';
  ext?: 'png' | 'jpg';
}

const printerImageMap = {
  'tm-m30': /^tm-?m30/i,
  'tm-t88': /^tm-?t88/i,
  tsp100: /^tsp1(?:00|43)/i,
  zd410: /^zd410$/i,
  lp2824: /^lp2824$/i,
};

export const getPrinterStaticImage = (model: string = ''): string => {
  if (!model) return '';

  const [image = ''] =
    Object.entries(printerImageMap).find(([, regExp]) => regExp.test(model)) || [];

  return image;
};

export const getPrinterStaticImagePath = ({
  image,
  srcSetScale,
  ext = 'png',
}: StaticImagePathProps): string => {
  if (!image) return '';
  const suffix = srcSetScale ? `@${srcSetScale}.${ext} ${srcSetScale}` : `.${ext}`;
  return `${getCFDAppUrl()}/assets/printers/model/${image}${suffix}`;
};
